import { DatePipe } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LABELS } from '../../constants/labels.const';
import { EvidenceItem } from '../../models/evidence.model';

export const EVIDENCE_PAGE_SIZES = [25, 50, 100, 300] as const;
export const EVIDENCE_DEFAULT_PAGE_SIZE = 50;

/**
 * One plot can hold over a thousand documents (Supplier Portal attaches a
 * whole submission's files to every plot in it), so the list is paged on the
 * client; the page itself is one request. Only file items reach this table.
 */
@Component({
  selector: 'ev-evidence-table',
  imports: [RouterLink, DatePipe],
  templateUrl: './evidence-table.component.html',
  styleUrl: './evidence-table.component.scss'
})
export class EvidenceTableComponent {
  readonly items = input.required<EvidenceItem[]>();
  readonly token = input.required<string>();

  readonly labels = LABELS.table;
  readonly pageSizes = EVIDENCE_PAGE_SIZES;

  readonly page = signal(1);
  readonly pageSize = signal<number>(EVIDENCE_DEFAULT_PAGE_SIZE);

  readonly pageCount = computed(() =>
    Math.max(1, Math.ceil(this.items().length / this.pageSize()))
  );

  readonly visible = computed(() => {
    const start = (this.page() - 1) * this.pageSize();
    return this.items().slice(start, start + this.pageSize());
  });

  readonly rangeStart = computed(() =>
    this.items().length === 0 ? 0 : (this.page() - 1) * this.pageSize() + 1
  );

  readonly rangeEnd = computed(() =>
    Math.min(this.page() * this.pageSize(), this.items().length)
  );

  selectPageSize(size: number): void {
    this.pageSize.set(size);
    this.page.set(1);
  }

  goToPage(page: number): void {
    this.page.set(Math.min(Math.max(1, page), this.pageCount()));
  }

  fileType(item: EvidenceItem): string {
    return item.file_type?.toUpperCase() ?? '';
  }
}
